<template>
<div class="login">
        <div class="login__wrap">
            <div class="login__box login__box--join">
                <P class="login__title">평가위원 등록</P>
                <div class="login__inputs">

                    <div v-if="isLoading" class="loading-overlay">
                        <div class="spinner"></div>
                        <p>관리자에게 승인요청 이메일을 보내는중...</p>
                    </div>

                    <!--로그인 인풋-->
                    <div class="input-box__wrap input-box__wrap--double">
                        <div class="input-box">
                            <label>아이디</label>
                            <input type="text" v-model="state.id">
                        </div>
                        <div class="input-box">
                            <label>이름</label>
                            <input type="text" v-model="state.name">
                        </div>
                        <div class="input-box">
                            <label>비밀번호</label>
                            <input type="password" v-model="state.password">
                        </div>
                        <div class="input-box">
                            <label>비밀번호 확인</label>
                            <input type="password" v-model="state.passwordConfirm">
                        </div>
						<div class="input-box">
                            <label>기관</label>
                            <select style="width: 100%" v-model="searchOrg" @change="updateOrgName" disabled>
							    <option value="">기관을 선택해주세요</option>
								<option v-for="(org, index1) of orgDataList" :key="index1" :value="org.organizationCode">{{org.organizationName}}</option>
						    </select>
                        </div>
                        <div class="input-box">
                            <label>승인 코드</label>
                            <div class="input-with-button">
                                <input type="text" v-model="state.orgJoinCode" style="flex: 1;">
                                <button type="button" class="btn btn--secondary" @click="applyOrgCode(state.orgJoinCode)">적용</button>
                            </div>
                        </div>
                        <div class="input-box">
                        <label>이메일</label>
                        <input type="text" v-model="state.email">
                        </div>
                    </div>



<!-- 📜 이용약관 (스크롤 적용) -->
<div class="login__box login__box--terms">
    <p class="terms-title">이용약관</p>
    <div class="terms-content">
        <h3>제 1장 총칙</h3>
        <p><strong>제 1 조 (목적)</strong><br>
        이 이용약관은 “ezQAR (이하 "당 사이트")”에서 제공하는 인터넷 서비스(이하 '서비스')의 가입조건, 당 사이트와 이용자의 권리, 의무, 책임사항과 기타 필요한 사항을 규정함을 목적으로 합니다.</p>

        <p><strong>제 2 조 (용어의 정의)</strong><br>
            1. "이용자"라 함은 당 사이트에 접속하여 이 약관에 따라 당 사이트가 제공하는 서비스를 받는 회원 및 비회원을 말합니다.<br>
            2. “ezQAR”에서 제공하는 국가표준, 인증제도, 기술기준, 인증지원 정보를 말합니다.<br>
            3. "기관 관리자(IQC)", "평가위원(IQA)"이라 함은 서비스를 이용하기 위하여 당 사이트에 개인정보를 제공하여 아이디(ID)와 비밀번호를 부여 받은 자를 말합니다.<br>
            4. "아이디(ID)"라 함은 IQC와 IQA의 식별 및 서비스 이용을 위하여 자신이 선정한 문자 및 숫자의 조합을 말합니다.<br>
            5. "비밀번호"라 함은 IQC와 IQA이 자신의 개인정보 및 직접 작성한 비공개 콘텐츠의 보호를 위하여 선정한 문자, 숫자 및 특수문자의 조합을 말합니다.</p>

        

        <p><strong>제 3 조 (이용약관의 효력 및 변경)</strong><br>
            1. 당 사이트는 이 약관의 내용을 회원이 알 수 있도록 당 사이트의 초기 서비스화면에 게시합니다. 다만, 약관의 내용은 이용자가 연결화면을 통하여 볼 수 있도록 할 수 있습니다.<br><br>
            2. 당 사이트는 이 약관을 개정할 경우에 적용일자 및 개정사유를 명시하여 현행 약관과 함께 당 사이트의 초기화면 또는 초기화면과의 연결화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. <br>
            다만, 회원에게 불리하게 약관내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 공지합니다.<br> 
            이 경우 당 사이트는 개정 전 내용과 개정 후 내용을 명확하게 비교하여 이용자가 알기 쉽도록 표시합니다.<br><br>
            3. 당 사이트가 전항에 따라 개정약관을 공지하면서 “개정일자 적용 이전까지 회원이 명시적으로 거부의 의사표시를 하지 않는 경우 회원이 개정약관에 동의한 것으로 봅니다.”<br>
            라는 취지를 명확하게 공지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 않은 경우에는 개정약관에 동의한 것으로 봅니다.<br>
            회원이 개정약관에 동의하지 않는 경우 당 사이트 이용계약을 해지할 수 있습니다.</p>


        <p><strong>제 4 조(약관 외 준칙)</strong><br>
            1. 이 약관은 당 사이트가 제공하는 서비스에 관한 이용안내와 함께 적용됩니다.<br>
            2. 이 약관에 명시되지 아니한 사항은 관계법령의 규정이 적용됩니다.</p>

        <h3>제 2장 이용계약의 체결</h3>
        <p><strong>제 5 조 (이용계약의 성립 등)</strong><br>
        이용계약은 이용고객이 당 사이트가 정한 약관에 「동의합니다」를 선택하고, 당 사이트가 정한 회원가입양식을 작성하여 서비스 이용을 신청한 후, 당 사이트가 이를 승낙함으로써 성립합니다.</p>

        <p><strong>제 6 조 (회원가입)</strong><br>
        서비스를 이용하고자 하는 고객은 당 사이트에서 정한 회원가입양식에 개인정보를 기재하여 가입을 하여야 합니다.</p>

        <p><strong>제 7 조 (개인정보의 보호 및 사용)</strong><br>
            당 사이트는 관계법령이 정하는 바에 따라 회원 등록정보를 포함한 회원의 개인정보를 보호하기 위해 노력합니다. 회원 개인정보의 보호 및 사용에 대해서는 관련법령 및 당 사이트의 개인정보 보호정책이 적용됩니다. 
            <br>다만, 당 사이트 이외에 링크된 사이트에서는 당 사이트의 개인정보 보호정책이 적용되지 않습니다.</p>

        <p><strong>제 8 조 (이용 신청의 승낙과 제한)</strong><br>
            1. 당 사이트는 제6조의 규정에 의한 이용신청고객에 대하여 약관에 정하는 바에 따라 서비스 이용을 승낙합니다.<br>
            2. 당 사이트는 아래사항에 해당하는 경우에 대해서 회원가입을 승낙하지 아니하거나 이후 사전 통보 없이 취소할 수 있습니다.<br>
            - 회원가입 신청 시 내용을 허위로 기재한 경우<br> 
            - 기타 규정한 제반사항을 위반하며 신청하는 경우<br>
            - 다른 사람의 당 사이트 이용을 방해하거나 그 정보를 도용하는 등의 행위를 하였을 경우<br>
            - 당 사이트를 이용하여 법령과 본 약관이 금지하는 행위를 하는 경우</p>

        <p><strong>제 9 조 (회원 아이디 부여 및 변경 등)</strong><br>
            1. 당 사이트는 이용고객에 대하여 약관에 정하는 바에 따라 자신이 선정한 회원 아이디를 부여합니다.<br>
            2. 회원 아이디는 원칙적으로 변경이 불가하며 부득이한 사유로 인하여 변경 하고자 하는 경우에는 해당 아이디를 해지하고 재가입해야 합니다.<br>
            3. 회원은 회원가입 시 기재한 개인정보가 변경되었을 경우 온라인으로 직접 수정할 수 있습니다. 이때 변경하지 않은 정보로 인해 발생되는 문제에 대한 책임은 회원에게 있습니다.</p>



        <h3>제 3장 계약 당사자의 의무</h3>
        <p><strong>제 10 조 ("ezQAR"의 의무)</strong><br>
        1. 당 사이트는 이용고객이 희망한 서비스 제공 개시일에 특별한 사정이 없는 한 서비스를 이용할 수 있도록 하여야 합니다.<br>
        2. 당 사이트는 개인정보 보호를 위해 보안시스템을 구축하며 개인정보 보호정책을 공시하고 준수합니다.<br>
        3. 당 사이트는 회원으로부터 제기되는 의견이 합당하다고 판단될 경우에는, 적절한 조치를 취하여야 합니다.<br>
        4.당 사이트는 전시, 사변, 천재지변, 비상사태, 현재의 기술로는 해결이 불가능한 기술적 결함 기타 불가항력적 사유 및 이용자의 귀책사유로 인하여 발생한 이용자의 손해,<br>
        손실, 기타 모든 불이익에 대하여 어떠한 책임도 지지 않습니다.</p>

        <p><strong>제 11 조 (회원의 의무)</strong><br>
        1. 이용자는 회원가입 신청 또는 회원정보 변경 시 실명으로 모든 사항을 사실에 근거하여 작성하여야 하며, 허위 또는 타인의 정보를 등록할 경우 일체의 권리를 주장할 수 없습니다.<br>
        2. 당 사이트가 관계법령 및 개인정보 보호정책에 의거하여 그 책임을 지는 경우를 제외하고, 회원에게 부여된 아이디의 비밀번호 관리소홀, 부정사용 등에 의하여 발생하는 모든 결과에 대한 책임은 회원에게 있습니다.<br>
        3. 회원은 당 사이트 및 제 3자의 지식재산권을 침해해서는 안 됩니다.<br>
        4. 이용자는 당 사이트의 운영자, 직원, 기타 관계자를 사칭하는 행위를 하여서는 안 됩니다.<br>
        5. 이용자는 바이러스, 악성코드 등을 제작, 배포, 이용하여서는 아니 되고, 당 사이트의 승인 없이 광고하는 행위를 하여서는 안 됩니다.<br>
        6. 이용자는 당 사이트 및 제 3자의 명예를 훼손하거나 업무를 방해하거나, 외설적이거나, 폭력적이거나 기타 공서양속에 반하는 게시물, 쪽지, 메일 등을 게시, 전송, 배포하여서는 안 됩니다.</p>

        <h3>제 4장 서비스의 이용</h3>
        <p><strong>제 12 조 (서비스 이용 시간)</strong><br>
        1. 회원의 이용신청을 승낙한 때부터 서비스를 개시합니다. 단, 일부 서비스의 경우에는 지정된 일자부터 서비스를 개시합니다.<br>
        2. 업무상 또는 기술상의 장애로 인하여 서비스를 개시하지 못하는 경우에는 사이트에 공시하거나 회원에게 이를 통지합니다.<br>
        3. 서비스의 이용은 연중무휴, 1일 24시간을 원칙으로 합니다. 다만, 당 사이트의 업무상 또는 기술상의 이유로 서비스가 일시 중지 될 수 있습니다.<br>
        4. 회원으로 가입한 이후라도 일부 서비스 이용 시 서비스 제공자의 요구에 따라 특정회원에게만 서비스를 제공할 수 있습니다.<br>
        5. 서비스를 일정범위로 분할하여 각 범위별로 이용가능 시간을 별도로 정할 수 있습니다. 이 경우 그 내용을 사전에 공개합니다.</p>

        <p><strong>제 13 조 (홈페이지 저작권)</strong><br>
        1. 당 사이트가 게시한 본 홈페이지의 모든 콘텐트에 대한 저작권은 당 사이트에 있습니다. 다만, 게시물의 원저작자가 별도로 있는 경우 그 출처를 명시하며 해당 게시물의 저작권은 원저작자에게 있습니다.<br>
        2. 회원이 직접 게시한 저작물의 저작권은 회원에게 있습니다. 다만, 회원은 당 사이트에 무료로 이용할 수 있는 권리를 허락한 것으로 봅니다.<br>
        3. 당 사이트 소유의 콘텐트에 대하여 제3자가 허락 없이 다른 홈페이지에 사용 또는 인용하는 것을 금지합니다.</p>

        <p><strong>제 14 조 (서비스의 변경, 중단)</strong><br>
        1. 당 사이트는 기술상•운영상의 필요에 의해 제공하는 서비스의 일부 또는 전부를 변경하거나 중단할 수 있습니다. 당 사이트의 서비스를 중단하는 경우에는 30일 전에 홈페이지에 이를 공지하되, 다만 사전에 통지할 수 없는 부득이한 사정이 있는 경우는 사후에 통지를 할 수 있습니다.<br>
        2. 제1항의 경우에 당 사이트가 제공하는 서비스의 이용과 관련하여, 당 사이트는 이용자에게 발생한 어떠한 손해에 대해서도 책임을 지지 않습니다. 다만 당 사이트의 고의 또는 중대한 과실로 인하여 발생한 손해의 경우는 제외합니다.</p>


        <h3>제 5장 계약 해지 및 이용 제한</h3>
        <p><strong>제 15 조 (계약 해지)</strong><br>
        1. 회원은 언제든지 마이페이지 메뉴 등을 통하여 이용계약 해지 신청을 할 수 있으며, 당 사이트는 관련법 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다.<br>
        2. 회원이 계약을 해지할 경우, 관련법령 및 개인정보처리방침에 따라 당 사이트가 회원정보를 보유하는 경우를 제외하고는 해지 즉시 회원의 모든 데이터는 소멸됩니다.<br>
        3. 회원이 계약을 해지하는 경우, 회원이 작성한 게시물(공용게시판에 등록된 게시물 등)은 삭제되지 아니합니다.</p>

        <p><strong>제 16 조 (서비스 이용제한)</strong><br>
        1. 당 사이트는 회원이 서비스 이용에 있어서 본 약관 및 관련 법령을 위반하거나, 다음 각 호에 해당하는 경우 서비스 이용을 제한할 수 있습니다.<br>
        - 2년 이상 서비스를 이용한 적이 없는 경우<br>
        - 기타 정상적인 서비스 운영에 방해가 될 경우<br>
        2. 상기 이용제한 규정에 따라 서비스를 이용하는 회원에게 사전 통지 후 서비스 이용을 일시정지 등 제한하거나 이용계약을 해지 할 수 있습니다.<br>
        단, 불가피한 사유로 사전 통지가 불가능한 경우에는 그러하지 아니합니다.</p>

        <h3>제 6장 개인정보 보호</h3>
        <p><strong>제 17 조 (손해배상)</strong><br>
        당 사이트는 무료로 제공되는 서비스와 관련하여 회원에게 어떠한 손해가 발생하더라도 당 사이트가 고의 또는 과실로 인한 손해발생을 제외하고는 이에 대하여 책임을 부담하지 아니합니다.</p>

        <p><strong>제 18 조 (개인정보 보호 및 사용)</strong><br>
        1. 당 사이트는 관계법령이 정하는 바에 따라 회원 등록정보를 포함한 회원의 개인정보를 보호하기 위해 노력합니다.<br>
        2. 회원 개인정보의 보호 및 사용에 대해서는 관련법령 및 당 사이트의 개인정보 보호정책이 적용됩니다.</p>

        <p><strong>제 19 조 (서비스별 이용자 사전 동의 사항과 의무)</strong><br>
        당 사이트에 ‘기술정보를 제공하는 이용자는 자신의 기술정보에 대한 권리(특허권, 실용신안권, 디자인권, 상표권 등)를 법적으로 보호받기 위해서 필요한 조치를 스스로 취하여야 합니다. <br>
        당 사이트는 이용자의 권리 보장이나 취득 등을 위한 어떠한 명목의 의무나 책임도 부담하지 않고, 이를 보장하지 않으며, <br>
        이용자 개인의 행위(당 사이트의 서비스 이용 행위 일체를 포함)로 인한 어떠한 분쟁이나 어떠한 명목의 손실, 손해에 대해서도 법적 책임을 지지 아니합니다.</p>


        <h3>제 7장 기타 사항</h3>
        <p><strong>제 20 조 (운영정책)</strong><br>
            "ezQAR" 각종 게시물에 대한 운영정책은 방송통신심의위원회의 정보통신에 관한 심의규정에 기반하며 이를 위반할 경우, 
            "ezQAR" 운영정책에 의해 관련 게시물은 예고 없이 삭제, 이동될 수 있으며, 게시자(회원)는 아이디 이용제한 등 "ezQAR" 이용에 제한을 받을 수 있습니다.</p>

        <p><strong>제 21 조 (게시물 등록)</strong><br>
            게시물은 실명을 통해 등록합니다. 악성 글 등을 업로드 하실 경우 게시물 삭제 또는 게시자(회원)의 이용제한 등의 경고 조치가 가능합니다.<br>  
            1.타인의 개인정보를 이용한 활동이 발견될 경우, 해당 회원은 이용에 제한을 받을 수 있으며, 해당 계정은 본인인증 후에 정상적인 이용이 가능합니다.<br> 
            또한 여러 개의 아이디를 생성하여 허위신고를 하거나, 타인 사칭을 통한 문제 발생 시, 그에 따른 이용 제한을 받을 수 있습니다.</p>

        <p><strong>제 22 조 (게시물의 저작권)</strong><br>
            1. 게시물은 회원이 서비스를 이용하면서 게재한 글, 사진, 파일, 관련 링크 및 댓글 등을 말합니다.<br>
            2. 회원이 서비스에 등록하는 게시물로 인하여 본인 또는 타인에게 손해 및 기타 문제가 발생하는 경우, 회원은 이에 대한 책임을 질수 있으며 또한 명예훼손이나 개인정보 유출,<br> 
            저작권과 같은 법률에 위배되는 게시물 및 댓글은 관련 법안에 따라 민형사상 처벌을 받을 수 있으니 이 점 유의하여 주시기 바랍니다.</p>

        <p><strong>제 23 조 (게시물 제한규정(삭제 및 이동))</strong><br>
            1. 욕설/비속어 및 분란을 조장하는 게시물<br> 
            - 욕설 및 비속어가 담겨있거나, 연상시키는 내용<br> 
            - 이유 없이 회원 간의 분란을 발생시킬 여지가 있는 내용의 게시물 또는 댓글<br> 
            2. 게시판 및 자료실과 관련 없는 게시물<br> 
            - 각 주제 분야별로 나뉘어 있는 게시판 및 자료실의 주제와 관련 없는 내용<br> 
            3. 상업성 광고 및 홍보 글에 관한 게시물<br> 
            4. 개인정보의 유포에 관한 게시물<br> 
            - 타인, 혹은 본인의 메일주소/실명/사진/전화번호/주민등록번호 등의 개인정보 또는 해당 정보가 담겨 있는 내용<br> 
            5. 확인되지 않은 소문의 유포에 관한 게시물<br> 
            - 공개되었을 경우, 당사자의 권리침해가 우려되는 내용<br> 
            6. 정치적 견해 차이 및 인종/성별/지역/종교에 대한 차별, 비하하는 게시물<br> 
            - 인종/성별/지역/종교에 대한 차별적 발언 또는 비하하는 내용<br> 
            - 상이한 정치적 견해를 비하하거나 폄하하는 내용<br> 
            7. 타인을 사칭하거나 범죄행위에 관한 게시물<br> 
            - 공인이나 특정이슈와 관련한 당사자 또는 지인, 주변인 등을 사칭하여 게시물을 작성하거나, "ezQAR" 운영자를 사칭하여 작성된 내용<br> 
            - 범죄와 관련 있거나 범죄를 유도하는 행위를 포함하는 내용<br> 
            8. 저작권 위반에 관한 게시물<br> 
            - 기사, 사진, 동영상, 음원, 영상물 등 저작권에 의해 보호받는 콘텐츠와 관련된 내용 뉴스의 경우, 기사 내용의 전부 혹은 일부를 게시하는 경우에는 저작권에 저촉될 수 있기 때문에 링크(URL)만을 허용합니다.<br> 
            - 음원, 사진, 동영상 등 해당 자료에 대한 불법공유를 목적으로 작성한 내용 공유를 목적으로 이메일을 수집하는 행위도 동일하게 처리됩니다.<br> 
            9. 악성코드/스파이웨어/혐오감 조성에 관한 게시물<br> 
            - 악성코드 및 스파이웨어의 유포 및 유도 관련 게시물은 사전경고 없이 제재를 받을 수 있습니다.<br> 
            - 시각 및 청각적으로 타인에게 혐오감을 줄 수 있는 게시물은 사전경고 없이 제재를 받을 수 있습니다.<br> 
            10. 기타 서비스 운영에 지장을 초래할 수 있는 게시물</p>
        
        <p><strong>제 24 조 (이용제한)</strong><br>
            1. 게시물 제한규정(3조)에 해당하는 내용을 게재하는 경우<br> 
            2. 다량의 게시물 등록을 목적으로 의미 없는 제목을 사용하거나, 반복되는 제목을 사용하여 게재하는 경우<br> 
            3. 비정상적인 방법으로 게시물을 등록, 조회 및 추천하는 경우 등</p>

        <p><strong>제 25 조 (게시중단 요청 서비스)</strong><br> 
            다른 회원의 게시물로 인하여 명예훼손, 저작권 침해 등의 피해를 입었을 경우, 운영담당자를 통해 해당 게시물에 대한 게시중단을 요청하실 수 있습니다.</p>

        <p><strong>[부 칙]</strong><br> 
            (시행일) 이 약관은 2016년 12월 30일부터 적용되며, 종전 약관은 본 약관으로 대체되며, 개정된 약관의 적용일 이전 가입자도 개정된 약관의 적용을 받습니다.</p>
    </div>
</div>
                    <!-- ✅ 이용약관 체크박스 -->
                    <th>
                        <input type="checkbox" id="check_1" v-model="terms.agree">
                        <label for="check_1">이용약관에 동의 하시겠습니까?</label>
                    </th>

<!-- 📜 이용약관 (스크롤 적용) -->
<div class="login__box login__box--terms">
    <p class="terms-title">개인정보 취급방침</p>
    <div class="terms-content">
        <h3>1. 개인정보 수집 원칙</h3>
        <p><strong>아트너컨설팅는 회원의 개인정보를 보호하는 동시에 적절한 서비스를 제공하기 위하여 다음과 같은 기본 원칙을 가지고 정보를 수집하고 있습니다.</strong><br>
            - 아트너컨설팅는 이용자들이 서비스를 최대한 효과적으로 이용하도록 하기 위하여 반드시 필요한 최소한의 정보만을 요구합니다.<br>
            - 회원 개개인의 개인정보는 회원 본인만이 직접 관리하실 수 있습니다.<br>
            - 아트너컨설팅는 회원들의 개인정보를 극히 예외적인 일부 상황(정부기관의 합법적인 요청 등) 외에는 공개하지 않는 것을 원칙으로 하고 있습니다.<br>
            - 아트너컨설팅는 회원의 개인정보가 상업 및 정치적 목적에 악용되는 것과 사생활 침해를 막기 위하여 최소한의 정보만을 요구합니다.</p>


        <h3>2 . 회원에게 요청하는 개인정보의 내용</h3>
        <p><strong>아트너컨설팅에서 제공하는 여러가지 커뮤니티 서비스를 이용하시려면 회원가입 화면에서 다음과 같은 기본 필수 항목을 입력하셔야 합니다.
            <br>아래의 항목을 제외하고는 선택사항입니다. 아트너컨설팅는 이용자가 선택항목에 정보를 기입하지 않은 이유로 기본적인 서비스 제공을 거부하지 않습니다.
        </strong><br>
            - 아이디(ID)<br>

            - 비밀번호<br>

            - 이름<br>

            - E-mail주소<br><br>

            아트너컨설팅는 이용자의 기본적 인권을 현저하게 침해할 우려가 있는 다음 항목의 내용을 포함하는 개인정보를 수집하지 않습니다.<br><br>

            - 인종 및 민족<br>

            - 사상 및 신조<br>

            - 출신지 및 본적지<br>

            - 정치적 성향 및 범죄기록<br>

            - 건강상태 및 성생활</p>

        
        <h3>3. 개인정보의 수집 동의 및 수집 방법</h3>
        <p><strong>
            회원가입시 아트너컨설팅의 이용약관 및 개인정보보호정책에 대해 [동의] 또는 <br>[동의하지 않음] 버튼을 선택하여 클릭할 수 있습니다. <br>
            [동의]를 클릭하면 개인정보 수집에 동의한 것으로 간주하고 가입양식에 입력한 사항을 바탕으로 개인정보를 수집합니다.
        </strong><br></p>
           
    
        <h3>4. 개인정보의 수집 및 이용 목적</h3>
        <p><strong>아트너컨설팅가 수집한 개인정보는 다음과 같은 용도로 이용됩니다.</strong><br>
            - 회원의 서비스 이용 계약 및 이행<br>

            - 커뮤니티 서비스의 제공<br>

            - 기타 새로운 서비스 또는 이벤트 정보 제공</p> 
            

            <h3>5. 목적외 사용 및 제3자와의 공유</h3>
        <p><strong>아트너컨설팅는 회원 개개인의 동의없이 결코 개인정보를 공유하지 않는 것을 원칙으로 하고 있습니다. <br>
            다만 관계 법령에 따라 다음과 같은 경우는 예외로 하고 있습니다.</strong><br>

            - 금융실명거래및비밀보장에관한법률, 신용정보의이용및보호에관한법률, 전기통신기본법, 전기통신사업법, 지방세법, 소비자보호법, 한국은행법, 형사소송법 등 법령에 특별한 규정이 있는 경우<br>

            - 서비스 제공에 따른 요금정산을 위해 필요한 경우<br>

            - 상품 배송 등 제휴사의 서비스 이행을 위해 부득이하게 협력제휴사와 일부 개인정보 공유가 필요한 경우에는 반드시 회원님의 동의를 받겠습니다.</p> 


            <h3>6. 개인정보보호를 위한 대책</h3>
        <p><strong>아트너컨설팅는 개인정보보호를 위해 먼저 기술적 측면에서 다음과 같은 조치를 취하고 있습니다.</strong><br>
            - 비밀번호 등을 이용한 보안장치<br>

            - 백신 프로그램을 이용한 컴퓨터바이러스 방지장치<br>

            - 암호알고리즘 등을 이용하여 개인정보를 안전하게 전송할 수 있는 보안장치<br>

            - 해킹 등 침입을 차단하는 시스템 및 접근통제장치<br>

            - 기타 안전성 확보를 위해 필요한 기술적 장치<br><br>

            또 관리적 측면에서는 다음과 같은 조치를 취하고 있습니다.<br><br>

            - 개인정보에 대한 접근 및 관리 절차 제정 실천<br>

            - 개인정보 처리 시스템의 사용자 지정 및 정기적 비밀번호 갱신<br>

            - 개인정보 취급자를 최소한의 인원으로 제한 지정<br>


            <strong>그럼에도 불구하고 회원 여러분의 개인정보는 기본적으로 아이디(ID)에 따른 비밀번호에 의해 보호된다는 점에 대해 경각심을 가져 주시기 바랍니다.

            비밀번호는 오로지 본인에 의해 관리되며 비밀번호 등에 대한 비밀을 유지할 책임은 아트너컨설팅 이용약관에 명시되어 있는 대로 회원 본인에게 있습니다.

            따라서, ID와 비밀번호는 반드시 문자와 숫자 등을 혼합하여 사용하시고, 주민등록번호나 전화번호 등 자주 사용하거나 노출되선 곤란한 정보를 이용하는 것은 바람직하지 않습니다. 또 비밀번호는 자주 바꿔주는 것이 좋습니다.

            네트워크를 통해 다른 사람과 컴퓨터를 공유하고 있는 경우 또는 공공장소에서 컴퓨터를 사용하여 아트너컨설팅에 접속한 후에는 로그아웃 메뉴를 이용하여 해당계정을 종료하시고, 웹 브라우저의 창을 닫아주셔야 합니다. 정상적으로 로그아웃을 하시지 않은 경우 웹 브라우저의 임시 저장소에 회원님의 개인정보가 고스란히 남아 있을 수 있습니다.

            아트너컨설팅는 개인정보보호에 최선을 다하고 있으나, 회원 본인의 실수로 ID와 비밀번호를 유출하였거나 인터넷 이용 상의 문제로 인한 피해에 대해서는 책임을 지지 않습니다.
            </strong></p>


            <h3>7. 개인정보의 보유 및 이용기간</h3>
        <p><strong>회원님의 개인정보는 가입일로부터 탈퇴일까지 서비스 제공을 위해 아트너컨설팅가 보유하게 됩니다.<br>
             이용계약을 해지하고 회원탈퇴를 하신 경우라도 상법 등 법령의 규정에 의한 예외 규정이 있거나 또는 이용자 본인의 동의를 받았을 경우, <br>
             보유기간을 사전에 고지한 경우 등에는 필요한 기간 동안 개인정보는 보유됩니다. 소송이나 분쟁, <br>
             상거래 대금지급 및 배송 등의 완료 등을 이런 사유의 예로 들 수 있습니다. 이 기간의 개인정보 열람 및 이용은 해당 사유로 국한됩니다.<br>
            위 기간이 지난뒤에도 계속 보유할 필요가 있을 경우 회원님께 고지하고 동의 절차를 거치겠습니다.</strong><br>

            아트너컨설팅는 개인정보의 수집목적 또는 제공받은 목적을 달성한 이후에는 지체없이 재생불가능한 기술적 방법을 사용하여 개인정보를 파기하고 있습니다.<br>
        
        </p> 


        <h3>8. 기타사항</h3>
        <p><strong>아트너컨설팅는 건전한 인터넷 사이트를 만들기 위하여 최선을 다하고 있습니다.<br>
            이를 위하여 미풍양속을 어기는 문구나 행위를 한 경우 및 다른 회원에게 피해를 주는 등의 행위를 한 불량 회원의 판별을 위해 게시물을 모니터링할 수 있습니다.<br>
            회원 개인정보 관리의 경우 회사로부터 관리권한을 부여받은 극소수의 직원만 가능하며, 회원의 개인정보 보호에 최선을 다합니다.</strong><br></p> 



        <h3>9. 개인정보 관리 책임자</h3>
        <p><strong>아트너컨설팅는 개인정보에 대한 의견 수렴과 불만 처리를 담당하는 관리책임자를 다음과 같이 지정하고 있습니다.</strong><br>
            - 성명: 주식회사 아트너컨설팅 추부금<br>

            - 메일: buchu@artner.co.kr<br>

            - 전화번호: 070-4489-9050</p> 


        <h3>개인정보 관련 불만사항 및 분쟁의 처리</h3>
        <p><strong>개인정보와 관련된 문의나 불만 사항은 위의 연락처나 정부에서 운영중인 개인정보침해신고센터 (http://www.cyberprivacy.or.kr 전화 02-1336)에
            처리를 신청하시고 개인정보에관한 분쟁이 있는 경우에는 한국정보보호센터 내의 개인정보분쟁조정위원회에 처리를 의뢰하시기 바랍니다.</strong><br></p> 



    </div>
</div>


                    <th>
                        <input type="checkbox" id="check_2" v-model="terms2.agree">
                        <label for="check_2">개인정보 취급방침에 동의 하시겠습니까?</label>
                    </th>


                    <button type="button" class="btn btn--primary btn--half" @click="goJoin">평가위원 등록</button>
                    <!--로그인 옵션-->
                    <!-- <div class="login__option">
                        <a class="login__option--left" @click="goMenu('user')" src="">로그인하기</a>
                    </div> -->

                </div>
            </div>
            <!-- <p class="login__help">
                <span>로그인 문의</span>
                <a href="tel:1588-3740">1588-3740</a>
            </p> -->
        </div>
    </div>
</template>
   
<script setup>
import { ref, computed, onMounted, onUnmounted ,reactive  } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import * as Utils from '@/common/util/util'
import { userJoin,sendAdminEmail } from '@/api/user'
import { joinOrgCode } from '@/api/org'
const store = useStore()
const router = useRouter()
const searchOrg = ref('') // 초기값을 빈 문자열로 설정
const userPriv = ref('user')
const orgName = ref('')
const isLoading = ref(false) // 로딩 상태 변수 추가
const terms = reactive({ agree: false });
const terms2 = reactive({ agree: false });
const onChange = () => {
  // 선택된 값에 대한 작업을 수행합니다.

};

const state = reactive({
    id: '',
    password: '',
    passwordConfirm : '',
    name : '',
    email : '',
    orgJoinCode : '',
});

// const formatPhoneNumber = (number) => {
//     // 숫자가 11자리인지 확인
//     const plainNumber = number.replace(/[^0-9]/g, ''); // 숫자만 추출
//     if (plainNumber.length !== 11) {
//         alert("핸드폰 번호는 숫자 11자리여야 합니다.");
//         return null;
//     }

//     // 010-1234-1234 형식으로 변환
//     return plainNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
// };

const updateOrgName = () => {
  const selectedOrg = orgDataList.value.find(org => org.organizationCode === searchOrg.value);
  orgName.value = selectedOrg ? selectedOrg.organizationName : '';
  //console.log("기관 콤보박스 변경 : " + orgName.value)
};

const orgDataList = computed(() => {
	return store.state.grid.orgData
})

const getComboData = async () => {
	await store.dispatch('grid/fetchOrg')
}

const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

const checkField = () => {

    if(terms.agree == false){
        alert("이용약관에 동의 해주세요")
		return false
    }
    if(terms2.agree == false){
        alert("개인정보 취급방침 약관에 동의 해주세요")
		return false
    }
    
    if (Utils.isEmpty(state.id)) {
		alert("아이디를 입력해주세요")
		return false
	}

	if (Utils.isEmpty(state.password)) {
		alert("비밀번호를 입력해주세요")
		return false
	}
	if (Utils.isEmpty(state.passwordConfirm)) {
		alert("비밀번호 확인창을 확인해주세요")
		return false
	}
	if (Utils.isEmpty(state.name)) {
		alert("이름을 입력해주세요")
		return false
	}      
   
    if (state.password != state.passwordConfirm) {
		alert("비밀번호와 비밀번호 확인 값이 다릅니다.")
		return false
	}

	if (state.organizationCode == "") {
		alert("기관을 선택해주세요")
		return false
	}
    if (state.email == "") {
		alert("이메일을 입력해주세요")
		return false
	}

    if (!validateEmail(state.email)) {
        alert("올바른 이메일 형식이 아닙니다.")
        return false
    } 
	return true
}

const applyOrgCode = async () => {
    if (!state.orgJoinCode) {
        alert("기관 코드를 입력해주세요!");
        return;
    }

    let param = {
        orgJoinCode: state.orgJoinCode
    };

    // 초기 콤보박스 값을 저장
    const initialSearchOrg = searchOrg.value;

    try {
        const resultVo = await joinOrgCode(param);

        if (resultVo?.result === 'ok') {
            // 결과로 받은 orgCode를 searchOrg에 매핑
            searchOrg.value = resultVo.orgCode;

            // 선택된 기관에 맞는 값을 업데이트
            const selectedOrg = orgDataList.value.find(org => org.organizationCode === resultVo.orgCode);
            if (selectedOrg) {
                state.organizationName = selectedOrg.organizationName;
            }

            alert("기관 코드가 성공적으로 적용되었습니다.");
        } else {
            // 실패 시 초기 콤보박스 값으로 복원
            searchOrg.value = '';
            alert(resultVo.resultMsg || "기관 코드 적용에 실패했습니다.");
        }
    } catch (error) {
        console.error("기관 코드 적용 중 오류 발생:", error);

        // 오류 발생 시 초기 콤보박스 값으로 복원
        searchOrg.value = '';
        alert("오류가 발생했습니다. 다시 시도해주세요.");
    }
};
 

const goJoin = async () => {
    if (!checkField()) { return false }

    if (confirm("등록하시겠습니까?")) {
        isLoading.value = true; // 로딩 시작

        try {
            // 회원가입 로직 먼저 처리
            let param = {
                id: state.id,
                memberPassword: state.password,
                memberName: state.name,
                organizationCode: searchOrg.value,
                userMail: state.email,
                privilege: 'user',
                state : '1'
            }

            const resultVo = await userJoin(param);

            if (resultVo?.result === 'ok') {
                alert("평가위원(IQA) 등록이 성공적으로 완료되었습니다. ");
                router.push({ name: 'login' });
            } else {
                alert(resultVo.resultMsg); // 회원가입 실패 메시지
            }
        } catch (error) {
            console.error("오류 발생:", error);
        } finally {
            isLoading.value = false; // 로딩 종료
        }
    }
};


onMounted(async () => {
	
  await getComboData()
  
})
</script>

<style scoped>
    .login{
    height: 100vh;
    }

	.loading-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		color: white;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		z-index: 1000;
	}
	
	.spinner {
		border: 5px solid rgba(255, 255, 255, 0.3);
		border-top: 5px solid white;
		border-radius: 50%;
		width: 50px;
		height: 50px;
		animation: spin 1s linear infinite;
	}
	
	@keyframes spin {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}
    .btn--half {
    width: 50%; /* 부모 요소의 절반 크기 */
    margin: 0 auto; /* 중앙 정렬 */
    display: block; /* 블록 요소로 설정 */
    text-align: center; /* 텍스트 중앙 정렬 */
    }

    select[disabled] {
    background-color: #f5f5f5; /* 비활성화된 느낌의 배경색 */
    color: #a0a0a0; /* 글자 색상 흐리게 */
    cursor: not-allowed; /* 커서 변경 */
    opacity: 0.6; /* 투명도 추가 */
    }

        /* 기관 코드와 버튼을 나란히 배치 */
    .input-box--with-button {
        display: flex;
        align-items: center;
    }

    .input-with-button {
        display: flex;
        gap: 10px; /* 입력란과 버튼 사이 간격 */
        width: 100%;
    }

    .input-with-button input {
        flex: 1; /* 입력란이 남은 공간을 모두 차지 */
    }

    .btn--apply {
        background-color: #4CAF50; /* 녹색 버튼 */
        color: white;
        border: none;
        padding: 6px 12px;
        font-size: 0.875rem;
        cursor: pointer;
        border-radius: 4px;
        transition: background-color 0.2s;
    }

    .btn--apply:hover {
        background-color: #45a049;
    }


        /* 📝 약관 컨테이너 */
.login__box--terms {
  border: 1px solid #ccc;
  padding: 15px;
  background: #fff;
  max-width: 100%;
  width: 100%;
  margin-top: 6px;
}


/* 📝 버튼 스타일 */
.btn--half {
  width: 50%;
  margin: 10px auto;
  display: block;
}

/* 📝 이용약관 컨테이너 */
.login__box--terms {
  border: 1px solid #ccc;
  padding: 15px;
  background: #fff;
  max-width: 100%;
  width: 100%;
  margin-top: 6px;
}

/* 📝 이용약관 제목 */
.terms-title {
  font-size: 18px;
  font-weight: bold;
  color: #0056b3; /* ✔ 파란색 제목 */
  margin-bottom: 10px;
}

/* 📝 이용약관 텍스트 박스 (스크롤 적용) */
.terms-content {
  font-size: 14px;
  color: #333;
  line-height: 1.8;
  max-height: 350px; /* ✔ 높이 조정 */
  overflow-y: auto; /* ✔ 스크롤 적용 */
  padding: 15px;
  border: 1px solid #ddd;
  background: #f9f9f9;
}

/* 📝 장 제목 스타일 */
.terms-content h3 {
  font-size: 16px;
  font-weight: bold;
  color: #0056b3; /* ✔ 파란색 섹션 제목 */
  margin-top: 20px;
  border-bottom: 2px solid #0056b3; /* ✔ 구분선 추가 */
  padding-bottom: 5px;
}

/* 📝 조항 제목 스타일 */
.terms-content p strong {
  font-weight: bold;
  color: #222;
  display: block;
  margin-top: 12px;
  font-size: 15px;
}

/* 📝 목록 스타일 */
.terms-content ul {
  padding-left: 20px;
}

.terms-content li {
  list-style-type: disc;
  margin-bottom: 5px;
}

/* 📝 주요 내용 강조 */
.terms-content p {
  margin-bottom: 10px;
}

/* 📝 블릿 스타일 */
.terms-content p::before {
  color: #0056b3;
  font-weight: bold;
}

/* 📝 체크박스 */
.terms-checkbox {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.terms-checkbox input {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #0056b3; /* ✔ 체크박스 파란색 */
}

.terms-checkbox label {
  font-size: 14px;
  color: #333;
  cursor: pointer;
}


</style>